module.exports = __webpack_public_path__ + "images/peter_hacker.png?v=5e4595675d0237ccea6b6d02a8a15c73";